import { render, staticRenderFns } from "./time-range-defaultValue-editor.vue?vue&type=template&id=12ed1d6b&scoped=true&"
import script from "./time-range-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./time-range-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed1d6b",
  null
  
)

export default component.exports